import React, { Component } from 'react'
import styles from './SubscriptionView.module.scss'
import { withRouter } from "react-router-dom"
import { strings } from '../../../components/utils/translations'
import classnames from 'classnames'
import moment from 'moment'
import { Utils } from '../../../components/utils/utils'
import { EXPIRATION_DAYS_SHOW_WARNING } from '../../../components/VRExpirationTag/VRExpirationTag'
import { notification, Modal, Button as AntdButton } from 'antd'
import CloseIcon from '../../../img/icons/closeIcon'
import API from '../../../components/utils/API'

class SubscriptionView extends Component
{
    state =
    {
        isLoadingStart: false,
        isLoadingRenew: false,
        isLoadingPayment: false,
        isLoadingCancel: false,
        
        showSubscriptionModal: false
    }
    
    
    render()
    {
        let s = this.props.subscription
        let allVirtualRemotes = this.props.allVirtualRemotes
        
        let isLoading = this.state.isLoadingStart ||
                        this.state.isLoadingRenew || 
                        this.state.isLoadingPayment || 
                        this.state.isLoadingCancel
        
        let {
            isExpired,
            daysTilExpiration,
            paymentAdded,
            paymentSuspended,
            is5years,
            isPastDue
        } = Utils.getVRisExpired(s?.virtualRemotes[0])
        
        let subscriptionTypeStyle = styles.permanent
        let icon = require('../../../img/icons/remote_gray.svg').default
        let title = strings('virtualRemote')
        let subtitle = strings('subscriptionPermanentSubtitle')
        let expirationDate = '-'
        
        let doorsInfo = null
        
        let statusTagTypeStyle = null
        let statusTag = null
        
        let hasCancelButton = false
        let hasStartButton = false
        let hasAddPaymentButton = false
        let hasRenewButton = false
        
        let expiresSoon = false
        
        
        // By type
        if (s?.type === 'permanent')
        {
            title += ` ${strings('free').toLowerCase()}`
        }
        else if (s?.type.includes('1'))
        {
            subscriptionTypeStyle = styles.oneYear
            icon = require('../../../img/icons/remote_purple.svg').default
            title += ` 1 ${strings('year').toLowerCase()}`
            expirationDate = moment(s?.virtualRemotes[0]?.expireDate).format('D MMM yyyy')
        }
        else if (s?.type.includes('5'))
        {
            subscriptionTypeStyle = styles.fiveYears
            icon = require('../../../img/icons/remote_gold.svg').default
            title += ` 5 ${strings('years').toLowerCase()}`
            expirationDate = moment(s?.virtualRemotes[0]?.expireDate).format('D MMM yyyy')
        }
        
        // By status
        if (s?.status === 'trial')
        {
            // paymentSuspended: En la sub del tio que compra un trial, las dejamos suspendidas para que no se cobren
            // Hay que ocultar el botón "Añadir método de pago" porque no la va a pagar el usuario que las compra
            subtitle = paymentSuspended ?
                        strings('subscriptionInfoCancelledAddPayment')
                        :
                        (!isExpired ? (!paymentAdded ? strings('subscriptionInfoAddPayment') :
                                                       strings('subscriptionInfoTrial'))
                                    : strings('subscriptionInfoTrialExpired'))
            
            statusTagTypeStyle = styles.trial
            statusTag = strings('trialMode')
            
            hasCancelButton = true
            hasStartButton = isExpired && !paymentAdded
            hasAddPaymentButton = !paymentSuspended && !paymentAdded && !isExpired && !hasStartButton
            
            expiresSoon = (!paymentAdded && daysTilExpiration <= EXPIRATION_DAYS_SHOW_WARNING)
        }
        else if (s?.status === 'active')
        {
            subtitle = strings('subscriptionInfoActive')
            
            statusTagTypeStyle = styles.active
            statusTag = strings('active')
            
            hasCancelButton = true
        }
        else if (s?.status === 'cancelled')
        {
            subtitle = paymentAdded ? strings('subscriptionInfoCancelled') :
                                      strings('subscriptionInfoCancelledAddPayment')
            statusTag = strings('cancelled')
            
            hasAddPaymentButton = !isExpired && !paymentAdded
            hasRenewButton = !isExpired
        }
        else if (s?.status === 'past_due')
        {
            subtitle = strings('pastDueInfo')
            
            statusTagTypeStyle = styles.trial
            statusTag = strings('pastDue')
            
            hasCancelButton = true
            hasAddPaymentButton = true
            
            expiresSoon = true
        }
        
        
        if (isExpired)
        {
            statusTagTypeStyle = styles.trial
            statusTag = strings('expired')
        }
        
        if (s?.virtualRemotes.length)
        {
            let allRemotes = allVirtualRemotes

            if (s?.virtualRemotes.length > 1)
                allRemotes = Object.groupBy(allVirtualRemotes, vr => vr.virtualRemoteId)
            
            doorsInfo = <div className={styles.doorsInfoContainer}>
                            {
                                (s?.virtualRemotes.length === 1) ?
                                <>
                                    <div className={styles.doorsInfoTitle}>
                                        { strings('subscriptionDoorsInfoTitle') }
                                    </div>
                                    <div className={styles.doorsInfo}>
                                        { 
                                            allRemotes?.map(vr => this.renderDoorsInfoItem(vr))
                                        }
                                    </div>
                                </>
                                :
                                <>
                                    <AntdButton
                                        className={styles.smallButton}
                                        size="small"
                                        onClick={() => this.setState({ showSubscriptionModal: true })}
                                    >
                                        { strings('subscriptionDoorsInfoTitlePlural') }
                                    </AntdButton>
                                    
                                    <Modal
                                        title={strings('subscriptionDoorsInfoTitlePlural')}
                                        visible={this.state.showSubscriptionModal}
                                        onCancel={() => this.setState({ showSubscriptionModal: false })}
                                        centered
                                        footer={null}
                                        autoFocusButton={null}
                                        className={styles.subscriptionModal}
                                        bodyStyle={{ paddingTop: 0 }}
                                    >
                                        <div className={styles.doorsInfo}>
                                            {
                                                Object.keys(allRemotes)?.map((vrGroupId, i) => (
                                                <div key={`${vrGroupId}`} className={styles.doorsInfoGroup}>
                                                    <div className={styles.doorsInfoTitle}>
                                                        { `MANDO ${i+1} (${vrGroupId})` }
                                                    </div>
                                                    {
                                                        allRemotes[vrGroupId]?.map(vr => 
                                                            this.renderDoorsInfoItem(vr)
                                                        )
                                                    }
                                                </div>))
                                            }
                                        </div>
                                    </Modal>
                                </>
                            }
                        </div>
        }
        
        
        return (
            <div className={classnames(styles.subscriptionView, subscriptionTypeStyle)}>
                <div className={styles.topView}>
                    <div className={styles.iconContainer}>
                        <img src={icon} />
                        <div className={styles.numRemotes}>x{ s?.virtualRemotes?.length }</div>
                    </div>
                    
                    <div className={styles.mainView}>
                        <div className={styles.titleContainer}>
                            <div className={styles.title}>{ title }</div>
                            
                            {
                                statusTag &&
                                <div className={classnames(styles.statusTag, statusTagTypeStyle)}>{ statusTag }</div>
                            }
                        </div>
                        <div className={styles.subtitle}>{ subtitle }</div>
                        
                        <div className={styles.info}>
                            <span>{strings('subscriptionNumRemotes')}: <b>{s?.virtualRemotes?.length}</b></span>
                            <span className={styles.separator}></span>
                            <span>{strings('subscriptionExpirationDate')}: <b className={classnames({[styles.orange]: expiresSoon})}>{expirationDate}</b></span>
                            {
                                s?.price &&
                                <>
                                <span className={styles.separator}></span>
                                <span className={styles.price}><span>{ s?.price * s?.virtualRemotes?.length }€</span>/{is5years ? '5' : null}{is5years ? strings('years') : strings('year')}</span>
                                </>
                            }
                        </div>
                        
                        { doorsInfo }
                    </div>
                </div>
                
                {
                    (hasStartButton || hasAddPaymentButton || hasRenewButton || hasCancelButton) &&
                    <div className={styles.buttons}>
                        {
                            hasStartButton &&
                            <AntdButton
                                loading={this.state.isLoadingStart}
                                className={styles.button}
                                size="medium"
                                type="primary"
                                disabled={isLoading}
                                onClick={() => this.showBillingInfoModal()}
                            >
                                { strings('startSubscription') }
                            </AntdButton>
                        }
                        {
                            hasAddPaymentButton &&
                            <AntdButton
                                loading={this.state.isLoadingPayment}
                                className={styles.button}
                                size="medium"
                                type="primary"
                                disabled={isLoading}
                                onClick={() => this.showBillingInfoModal()}
                            >
                                { strings('addPaymentMethod') }
                            </AntdButton>
                        }
                        {
                            hasRenewButton &&
                            <AntdButton
                                loading={this.state.isLoadingRenew}
                                className={classnames(styles.button, styles.white)}
                                size="medium"
                                disabled={isLoading}
                                onClick={() => this.showRenewSubscriptionModal()}
                            >
                                { strings('subscriptionRenewSubscription') }
                            </AntdButton>
                        }
                        {
                            hasCancelButton &&
                            <AntdButton
                                loading={this.state.isLoadingCancel}
                                className={classnames(styles.button, styles.white)}
                                size="medium"
                                disabled={isLoading}
                                onClick={() => this.showCancelSubscriptionModal(isExpired)}
                            >
                                { strings('cancelSubscription') }
                            </AntdButton>
                        }
                    </div>
                }
            </div>
        )
    }
    renderDoorsInfoItem(vr)
    {
        let door = this.getDoor(vr.doorId)
        let user = vr.assignedUser ? `${vr.assignedUser.name} ${vr.assignedUser.lastName}` :
                                     (vr.reserved ? strings('pendingActivation') : strings('notUsed'))
        
        return (
            <div key={door?.id} className={styles.doorsInfoItem}>
                <div className={styles.door}>
                    <div className={styles.doorImage} style={{ backgroundImage: `url(${door?.imageURL})` }}></div>
                    <div className={styles.text}>{ door?.name }</div>
                </div>
                
                <div className={styles.separator}></div>
                
                <div className={styles.user}>
                    {
                        vr.assignedUser &&
                        <div className={styles.userInitials}>{ Utils.getInitials(user) }</div>
                    }
                    <div className={classnames(styles.text, {[styles.noUser]: !vr.assignedUser, [styles.notUsed]: user === strings('notUsed')})}>
                        { user }
                    </div>
                </div>
            </div>
        )
    }
    
    getDoor(doorId)
    {
        let door = null
        
        door = this.props.house?.doors?.find(d => d.id === doorId)
        
        if (door == null)
        {
            for (let i = 0; i < this.props.house?.nodes?.length && door == null; i++)
            {
                door = this.props.house?.nodes[i]?.doors?.find(d => d.id === doorId)
            }
        }
        
        return door
    }
    
    showCancelSubscriptionModal(isExpired)
    {
        let text = ''
        
        if (!isExpired)
        {
            let s = this.props.subscription
            let expirationDate = moment(s?.virtualRemotes[0]?.expireDate).format('LL')
            text = `${strings('cancelSubscriptionModalText')}${expirationDate}${strings('cancelSubscriptionModalText2')}`
        }
        else
            text = strings('cancelSubscriptionModalTextExpired')
        
        Modal.confirm(
        {
            title: <div className={styles.modalTitle}>{ strings('cancelSubscriptionTitle') }</div>,
            content: <div className={styles.modalText}>{ text }</div>,
            okText: strings('cancelSubscription'),
            cancelText: strings('back'),
            onOk: () => this.cancelSubscription(),
            centered: true,
            autoFocusButton: null,
            closable: true,
            maskClosable: true,
            icon: null,
            okButtonProps: { size: "large" },
            cancelButtonProps: { size: "large" }
        })
    }
    showRenewSubscriptionModal()
    {
        let s = this.props.subscription
        let expirationDate = moment(s?.virtualRemotes[0]?.expireDate).format('LL')
        
        Modal.confirm(
        {
            title: <div className={styles.modalTitle}>{ strings('subscriptionRenewSubscriptionTitle') }</div>,
            content: <div className={styles.modalText}>{`${strings('renewSubscriptionModalText')} ${expirationDate}.`}</div>,
            okText: strings('subscriptionRenewSubscription'),
            cancelText: strings('back'),
            onOk: () => this.resumeSubscription(),
            centered: true,
            autoFocusButton: null,
            closable: true,
            maskClosable: true,
            icon: null,
            okButtonProps: { size: "large" },
            cancelButtonProps: { size: "large" }
        })
    }
    showBillingInfoModal()
    {        
        const modal = Modal.confirm(
        {
            title: <div className={styles.modalTitle}>{ strings('billingInfoModalTitle') }</div>,
            content: <div className={styles.modalText}>{ strings('billingInfoModalText') }</div>,
            okText: strings('goToBillingInfo'),
            cancelText: strings('continue'),
            onCancel: (e) => {
                modal.update({ cancelButtonProps: { loading: true }})
                
                if (e.triggerCancel == null)
                    this.createPaymentSession()
            },
            centered: true,
            autoFocusButton: null,
            closable: true,
            maskClosable: true,
            icon: null,
            width: 480,
            okButtonProps: { size: "large" },
            cancelButtonProps: { size: "large" },
            onOk: async () =>
            {
                modal.update({ okButtonProps: { loading: true }})
                
                try
                {
                    let currentUser = await API.getInstance().getCurrentUser()
                    let res = await API.getInstance().createPortalSession(currentUser?.email, this.props.house?.id)
                    
                    try
                    {
                        if (res.data?.response)
                            window.open(`${res.data?.response}`, '_blank').focus()
                    }
                    catch(error)
                    {
                        alert(strings('openManageInStripeWindowBlockedError'))
                    }
                }
                catch(error)
                {
                    console.log(error)
                    notification.error(
                    {
                        description: strings('error'),
                        placement: 'top'
                    })
                }
                finally
                {
                    modal.update({ okButtonProps: { loading: false }})
                }
            }
        })
    }
    
    async resumeSubscription()
    {
        try
        {
            this.setState({ isLoadingRenew: true })
            
            let res = await API.getInstance().resumeSubscription(this.props.subscription?.id)
            console.log(res)
            
            notification.success(
            {
                description: strings('subscriptionUpdateSuccessful'),
                placement: 'top',
                closeIcon: <></>
            })
            
            if (this.props.onSubscriptionChanged != null)
                this.props.onSubscriptionChanged()
        }
        catch (error)
        {
            console.log(error)
            notification.error(
            {
                description: strings('error'),
                placement: 'top'
            })
        }
        finally
        {
            this.setState({ isLoadingRenew: false })
        }
    }
    async createPaymentSession()
    {
        try
        {
            this.setState({ isLoadingPayment: true })
            
            let currentUser = await API.getInstance().getCurrentUser()
            let res = await API.getInstance().createPaymentSession(this.props.subscription?.id,
                                                                    this.props.house?.id,
                                                                    currentUser?.email)
            console.log(res)
            if (res.data?.status?.url)
                window.location.replace(res.data?.status?.url)
        }
        catch (error)
        {
            console.log(error)
            notification.error(
            {
                description: strings('error'),
                placement: 'top'
            })
        }
        finally
        {
            this.setState({ isLoadingPayment: false })
        }
    }
    async cancelSubscription()
    {
        try
        {
            this.setState({ isLoadingCancel: true })
            
            let res = await API.getInstance().cancelSubscription(this.props.subscription?.id)
            console.log(res)
            
            notification.success(
            {
                description: strings('subscriptionUpdateSuccessful'),
                placement: 'top',
                closeIcon: <></>
            })
            
            if (this.props.onSubscriptionChanged != null)
                this.props.onSubscriptionChanged()
        }
        catch (error)
        {
            console.log(error)
            let errorMEssage = error.response?.data?.error?.message
            notification.error(
            {
                message: 'Error',
                description: errorMEssage ? errorMEssage : strings('error'),
                placement: 'top'
            })
        }
        finally
        {
            this.setState({ isLoadingCancel: false })
        }
    }
}

export default withRouter(SubscriptionView)
